/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/barcode_scanner/ImageProcessor.yaml
import { ScanbotImageProcessorImpl } from './impl';
/**
 * Entry point for all image processing features.
 */
export const ScanbotImageProcessor = {
    /**
     * Reads image data from the given file uri and returns it as a Base 64 encoded string.
     * @param {string} imageFileUri - File uri of the image to be read.
     * @returns {Promise<string>} - The Base 64 encoded representation of the image.
     */
    async readImageData(imageFileUri) {
        return ScanbotImageProcessorImpl.readImageData(imageFileUri);
    },
};
//# sourceMappingURL=ImageProcessor.js.map